import Control from "../general/control";
import ProifleDetails from "../general/profiledetails";
import Slide from "react-reveal/Slide";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
import useAccount from "../../controllers/useAccount.js";
import account from "../../context/generalaccount.js";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { FcInvite } from "react-icons/fc";
export default function Account() {
  const data = useAccount();
  const { finaldetails, dploading, control, changeDp, reinvite, loading } =
    data;
  const navigate = useNavigate();
  if (!finaldetails) return "Loading....";
  return (
    <div>
      <div className="bg-[url('https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg')] w-[90%] bg-cover h-[200px] bg-no-repeat bg-left m-auto mt-4 rounded-lg"></div>
      <div className="m-auto w-[85%] shadow-lg -mt-4 bg-white rounded-lg p-4">
        <IoArrowBack
          className="scale-150 mb-2 cursor-pointer"
          onClick={() => navigate("/dashboard/table")}
        />
        <div className="flex space-x-2">
          <Fade top>
          <>
          <input
              type="file"
              className="w-[1px] h-[1px]"
              onChange={changeDp}
              id="dp-upload"
            />
            <img
              src={finaldetails.profileurl}
              alt="Profile"
              className={`w-20 h-20 rounded-lg cursor-pointer ${
                dploading ? "blur-xl" : ""
              }`}
              onClick={() => {
                if (!dploading) document.getElementById("dp-upload").click();
              }}
            />
            {!finaldetails.verified && (
              <FcInvite
                className={`scale-150 cursor-pointer  ${
                  !loading ? "hover:scale-[200%]" : ""
                }`}
                onClick={reinvite}
              />
            )}
          </>
          </Fade>
          <Zoom>
            <div className="mt-4">
              <p className="font-Roboto font-bold">
                {(finaldetails.firstname || "") +
                  " " +
                  (finaldetails.lastname || "")}
              </p>
              <p className="font-Roboto font-medium">
                {finaldetails.accountType}
              </p>
            </div>
          </Zoom>
        </div>
        <account.Provider value={data}>
          <div className="flex flex-wrap space-y-4 sm:space-x-10 ">
            {control && (
              <Slide left>
                <Control />
              </Slide>
            )}
            <Slide right>
              <ProifleDetails />
            </Slide>
          </div>
        </account.Provider>
      </div>
    </div>
  );
}
